import React from "react";

export default function Logo({ size = "md" }) {
  const sizes = { sm: 28, md: 36, lg: 44 };
  const h = sizes[size] || 36;
  const w = h;

  return (
    <img
      src="/logo.jpeg"
      alt="Scopuz"
      width={w}
      height={h}
      style={{ objectFit: "contain", display: "block", borderRadius: "20%" }}
    />
  );
}
